<script>
import CartItems from '../cart-items/cart-items.vue'
import { mapGetters } from 'vuex'
import BindMfa from '../bind-mfa/bind-mfa.vue'
import SaveCardInfo from '../save-card-info/save-card-info.vue'

export default {
  name: 'AuthReview',
  components: {
    CartItems,
    BindMfa,
    SaveCardInfo
  },
  data () {
    return {
      maskedCard: {},
      showSaveOption: true
    }
  },

  computed: {
    ...mapGetters(['enrollMaskCard', 'cartDetails', 'consumerContactInfo', 'consumerJwt', 'selectedSavedCardDetails', 'merchantSavedCards']),

    isLoggedIn: function () {
      return this.consumerJwt
    },

    containsSystemGenerated () {
      return this.consumerContactInfo.includes('SYSTEM_GENERATED')
    }
  },
  created () {
    if (
      !this.cartDetails ||
      Object.keys(this.$store.getters.products).length === 0
    ) {
      this.$router.push('/cart').catch((err) => {
        console.error(err)
      })
    }
    this.maskedCard = this.enrollMaskCard.digitalCardData ? this.enrollMaskCard : this.selectedSavedCardDetails.maskedCard
    let isCardExist = this.merchantSavedCards.filter(card => card.scofMaskedCard.panLastFour === this.maskedCard.panLastFour)
    if (isCardExist.length > 0) {
      this.showSaveOption = false
    } else {
      this.showSaveOption = true
    }
  },

  methods: {
    /**
     * This method routes to account page
     */
    goToAccountPage () {
      this.$router.push('/account').catch((err) => {
        console.error(err)
      })
    }
  }
}
</script>

<template>
  <div
    class="container"
    data-test="auth-review">
    <div class="row pt-4">
      <div class="col">
        <h3>
          {{ $t("header.cart") }}
        </h3>
      </div>
      <div
        v-if="!isLoggedIn"
        class="col">
        <small class="pull-right text-muted text-right">
          {{ $t("label.returnCustomer") }}
          <button
            id="sign-in"
            class="btn btn-primary btn-lg ml-2"
            type="button"
            @click="goToAccountPage()"
          >
            {{ $t("label.signIn") }}
          </button>
        </small>
      </div>
    </div>
    <div class="border-dark border-top my-2" />
    <div class="row">
      <div class="col-xs-12 col-sm-6 mt-5 mb-5">
        <h4 class="font-weight-bold pl-md-3">
          {{ $t("header.reviewOrder") }}
        </h4>
        <div
          v-if="cartDetails"
          class="pl-md-3  mb-md-5">
          <cart-items :cart-details="cartDetails" />
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 mt-4 pl-md-5 mt-5 mb-sm-5">
        <div
          id="card-payment-info"
          class="mb-3">
          <save-card-info
            :mask-card-detail="maskedCard"
            :is-checkbox-visible="showSaveOption"/>
        </div>
        <hr >
        <div v-if="!consumerContactInfo">
          <bind-mfa />
        </div>
        <div
          v-if="consumerContactInfo && !containsSystemGenerated"
          class="contactInfo">
          <h4 class="font-weight-bold mb-4">
            {{ $t ('header.contactInfo') }}
          </h4>
          <div>
            {{ consumerContactInfo || '' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
